import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { OrderService } from '@app/shared/services/order/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/shared/services/common/common.service';
import { IlistOrder, OrderFilter, OrderFilterEmitter } from '@app/feature/store-admin/components/reports/order-shopify/IlistOrder';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TrackingNumberPopupComponent } from '@app/feature/store-admin/components/reports/tracking-number-popup/tracking-number-popup.component';
import { IPayPalConfig } from 'ngx-paypal';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { EncrDecrService } from '@app/shared/services/encr-decr-service.service';
import { Constants, CryptoKeyValue, ReportOrderRequestStatus } from '@app/shared/constants';
import { ReportOrderComponent } from '../../../../../shared/dialogs/report-order/report-order.component';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';


@Component({
  selector: 'app-order-shopify',
  templateUrl: './order-shopify.component.html',
  styleUrls: ['./order-shopify.component.css']
})
export class OrderShopifyComponent implements OnInit {
  orderList: IlistOrder[] = [];
  orderFilter: OrderFilter = {
    storeId: 0,
    orderStatus: 0,
    orderedUserName: null,
    orderUserEmail: null,
    orderNumber: null,
    isOrderDesk: false,
    style: null,
    startDate: null,
    endDate: null
  };
  loaded = false;
  // For Infinite scroll of grid
  pageSize = 10; // No of items to load from server side i.e no of items to take
  initialItemsCount !: number;  // No of items to skip
  StoreId = 0;
  storeList: GetStoreInterface[] = [];
  orderId = 0;
  public payPalConfig?: IPayPalConfig;  // for paypal configuration
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;
  isFullListDisplayed: boolean = false;
  imgWareHouseBaseURL =  environment.warehouseProductCustomImageFolder;
  scrollDisabled: boolean = false;


  constructor(private orderService: OrderService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private http: HttpClient,
    private EncrDecr: EncrDecrService,
    private errorhandlerService: ErrorhandlerService) {
  }

  ngOnInit() {
    this.initialItemsCount = 0;
  }

  exportExcel() {
    this.loader.show();
    const ListOfStoresID = this.storeList.map((ele) => {
      return ele.StoreId;
    });
    this.orderService.ExportExcel(0,
      this.initialItemsCount,
      this.pageSize,
      this.orderFilter.orderStatus,
      this.orderFilter.storeId,
      ListOfStoresID,
      this.orderFilter.orderedUserName,
      this.orderFilter.orderUserEmail,
      this.orderFilter.orderNumber,
      this.orderFilter.isOrderDesk,
      this.orderFilter.style,
      this.orderFilter.startDate ? String(new Date(this.orderFilter.startDate).toLocaleDateString('en-GB')) : null,
      this.orderFilter.endDate ? String(new Date(this.orderFilter.endDate).toLocaleDateString('en-GB')) : null).subscribe((res) => {
      if (res.StatusCode === 200) {
        window.open(res.Data.ResponseData,'_blank');
      } else
        this.notificationService.error(res.Message, 'Error');

      this.loader.hide();
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  openTrackingNumberPopup(trackingNumber: string, TrackingUrl: string) {
    this.dialog.open(TrackingNumberPopupComponent, {
      data: { trackingNumber, TrackingUrl }
    });
  }
  onFilterSearchTrigger(data: OrderFilterEmitter) {
    this.storeList = data.storeList;
    this.fn_GetOrderListing(data.cleanup);
  }
  fn_clearFilter() {
    this.orderFilter.orderStatus = 0;
    this.orderFilter.storeId = 0;
    this.orderFilter.orderedUserName = null;
    this.orderFilter.orderUserEmail = null;
    this.orderFilter.orderNumber = null;
    this.orderFilter.style = null;
    this.orderFilter.startDate = null;
    this.orderFilter.endDate = null;
    this.orderFilter.isOrderDesk = false; 
    this.fn_GetOrderListing(true);
  }
  checkFilterApplied(){
    let obj: OrderFilter = {
      storeId: 0,
      orderStatus: 0,
      orderedUserName: null,
      orderUserEmail: null,
      orderNumber: null,
      isOrderDesk: false,
      style: null,
      startDate: null,
      endDate: null
    };
    if(JSON.stringify(this.orderFilter) != JSON.stringify(obj)) // JSON.stringify, key value pair order matters
      return true;
    else
      return false;
  }

  /** Func to get order listing */
  fn_GetOrderListing(cleanup: boolean = false) {
    if (cleanup) {
      this.orderList = [];
      this.initialItemsCount = 0;
      this.loader.show();
      this.isFullListDisplayed = false;
    } else {
      this.loader.hide();
      this.loader.lazyLoaderShow();
    }
    const ListOfStoresID = this.storeList.map((ele) => {
      return ele.StoreId;
    });
    this.scrollDisabled = true;
    this.orderService.GetOrdersShopify(0,
      this.initialItemsCount,
      this.pageSize,
      this.orderFilter.orderStatus,
      this.orderFilter.storeId,
      ListOfStoresID,
      this.orderFilter.orderedUserName,
      this.orderFilter.orderUserEmail,
      this.orderFilter.orderNumber,
      this.orderFilter.isOrderDesk,
      this.orderFilter.style,
      this.orderFilter.startDate ? String(new Date(this.orderFilter.startDate).toLocaleDateString('en-GB')) : null,
      this.orderFilter.endDate ? String(new Date(this.orderFilter.endDate).toLocaleDateString('en-GB')) : null).subscribe((res) => {
      this.scrollDisabled = false;
        if (res.StatusCode === 200) {
          this.fn_AddLazyLoadedItems(res.Data.ResponseData);
        } else if (res.StatusCode === 204) {
          if (this.orderList.length <= 0) {
            this.notificationService.error(res.Message, 'Record(s)');
          }
        }
        this.loader.lazyLoaderHide();
        this.loader.hide();
        this.loaded = true;
      }, (err: any) => {
        this.loader.lazyLoaderHide();
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      });
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {

    for (let i = 0; i < items.length; i++) {
      var shopifyTotal = 0;

      // check if item with same id exists
      if (!this.orderList.find(x => x.OrderId === items[i].OrderId)) {

        this.initialItemsCount = this.orderList.push(items[i]);

        //Reset prices according to role and application
        for (let j = 0; j < items[i].OrderItems.length; j++) {
          if (!items[i].OrderItems[j].ImageName) {
            // Check Design Huddle first
            if (items[i].OrderItems[j].AzureBlobThumbnailUrl) {
              items[i].OrderItems[j].ImageName = items[i].OrderItems[j].AzureBlobThumbnailUrl;
            } else {
              items[i].OrderItems[j].ImageName = this.imgBaseURL + items[i].OrderItems[j].PngRelativeUrlWithProduct;
            }
          } else {
            if (items[i].OrderItems[j].IsImageCustom)
              items[i].OrderItems[j].ImageName = this.imgCustomBaseURL + items[i].OrderItems[j].ImageName;
            else
              items[i].OrderItems[j].ImageName = this.imgBaseURL + items[i].OrderItems[j].ImageName;
          }

          if (items[i].IsOrderDeskOrder) {
            items[i].OrderItems[j].UnitPrice = items[i].OrderItems[j].UnitPrice + items[i].OrderItems[j].TotalPrintPrice;
            items[i].Discount = (items[i].SubTotal * items[i].OrderItems[j].Discount / 100).toFixed(2);
          }
          else {
            var finalCost = 0;
            var qty = 0;
            var profit = 0;
            var cost = items[i].OrderItems[j].EmbroideryCost;
            var printcost = items[i].OrderItems[j].PrintingCost;
            var finishingPrice = items[i].OrderItems[j].FinishingPrice;
            var sideCount = items[i].OrderItems[j].ProductSidesCount;
            var IsEmbroideryType = items[i].OrderItems[j].IsEmbroideryType;
            if (items[i].IsSampleOrder === true) {
              // if customization type embroidery
              if (IsEmbroideryType) {
                finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, 0, IsEmbroideryType);
              } else {
                finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, printcost, sideCount, 0)
              }
              //Apply discount if has any
              if (items[i].OrderItems[j].Discount > 0 && items[i].OrderItems[j].Discount != null) {
                //finalCost = finalCost - (finalCost * (items[i].OrderItems[j].Discount / 100));
                finalCost = this.commonService.fn_calculateDiscount(finalCost, items[i].OrderItems[j].Discount)
              }
              //No Disccount would be applicable for finshing price
              items[i].OrderItems[j].UnitPrice = finalCost;//+ items[i].OrderItems[j].FinishingPrice;

            }
            else {

              if (!items[i].IsShopifyOrder) {
                profit = items[i].OrderItems[j].RetailPrice;
                if (IsEmbroideryType) {
                  finalCost = finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, profit, IsEmbroideryType);
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, printcost, sideCount, profit)
                }
                items[i].OrderItems[j].UnitPrice = finalCost;
              } else {
                if (IsEmbroideryType) {
                  finalCost = finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, profit, IsEmbroideryType);
                  qty = items[i].OrderItems[j].Quantity
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(items[i].OrderItems[j].UnitPriceWithoutProfit, finishingPrice, printcost, sideCount, profit)
                  qty = items[i].OrderItems[j].Quantity
                }
                if (items[i].OrderItems[j].Discount > 0 && items[i].OrderItems[j].Discount != null) {
                  finalCost = this.commonService.fn_calculateDiscount(finalCost, items[i].OrderItems[j].Discount)
                }
                //No Disccount would be applicable for finshing price
                items[i].OrderItems[j].UnitPrice = finalCost;
                if(qty > 0)
                finalCost = finalCost * qty;
                shopifyTotal += finalCost;
              }
            }
            if (items[i].IsShopifyOrder && !items[i].IsSampleOrder)
              items[i].TotalPrice = shopifyTotal;
          }
        }

        if (items[i].IsShopifyOrder && !items[i].IsSampleOrder) {
          items[i].Discount = (items[i].TotalPrice * (items[i].OrderItems.length > 0 ? (items[i].OrderItems[0].Discount / 100) : 0)).toFixed(2);
          items[i].TotalPrice += items[i].ShippingCost;
        }
      }
    }
    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
  }


  changeOrderId(orderId: any) {
    this.orderId = orderId;
  }

  fn_RedirectToOrderDetail(orderNo: string) {
    this.loader.show();
    this.router.navigate(['/store/orderdetail', orderNo]);

  }
  fn_CrytoEncryptDecryptText(orderid: any) {
    //return this.EncrDecr.set(CryptoKeyValue.Key, String(orderid))
    return this.EncrDecr.set(CryptoKeyValue.Key, String(orderid))

  }

  fn_ShowReportOrder(order: IlistOrder) {
    // if order status is Shipped or Delivered, report is not submitted before and Shipped date not exceeded 60 days (Dates are in UTC)
    if (!order.IsOrderDeskOrder && ((order.OrderStatus === 'Dispatched' || order.OrderStatus === 'Delivered') && !order.ReportOrderStatus) && order.DispatchedDate
      && this.commonService.fn_CalculateDateDiff(new Date().valueOf(), new Date(order.DispatchedDate).getTime()) <= Constants.ReportOrderWithinDays)
      return true;
    else
      false;
  }
  fn_ReportOrderStatus(order: IlistOrder) {
    if (order.ReportOrderStatus) {
      const status = ReportOrderRequestStatus[order.ReportOrderStatus];
      return status;
    }
  }

  fn_ReportOrder(order: IlistOrder) {
    const dialogConfig: MatDialogConfig = {
      width: '600px',
      data: order
    };
    this.dialog.open(ReportOrderComponent, dialogConfig);
  }
  getColor(order: IlistOrder) {
    switch (order.ReportOrderStatus) {
      case 1:
        return '#17a2b8'; // blue
      case 2:
        return 'green';
      case 3:
        return 'red';
    }
  }

  getDate(date){
        let options: Intl.DateTimeFormatOptions  = { hour12: false, weekday:'long', day: 'numeric', month: 'long',  year: 'numeric'};
      return new Date(date).toLocaleDateString("en-US", options);
  }
}
